import { render, staticRenderFns } from "./SolutionsSwiper.vue?vue&type=template&id=85a6f2ba&scoped=true"
import script from "./SolutionsSwiper.vue?vue&type=script&lang=js"
export * from "./SolutionsSwiper.vue?vue&type=script&lang=js"
import style0 from "./SolutionsSwiper.vue?vue&type=style&index=0&id=85a6f2ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6f2ba",
  null
  
)

export default component.exports